import Client from './client';

export default class Tests extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/test`, options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/test`, {
      ...options,
       method: 'POST',
    });
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/test/${id}`, options);
  }

  putById(id, options = {}) {
    return this.makeRequest(`${this.host}/test/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteById(id, options = {}) {
    return this.makeRequest(`${this.host}/test/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
